const API_URL = process.env.REACT_APP_API ; 
// before users change their profile, sould firstly get their original data
const getUser = async (lineProfile) => {
  try {
    const response = await fetch(`${API_URL}/users`, {
      method: "GET",
      headers: {
        "x-line-id": lineProfile.userId,
      },
    });
    const jsonResponse = await response.json();
    console.log(`getUser api: jsonResponse ${JSON.stringify(jsonResponse)}`);
    return { error: jsonResponse.error, data: jsonResponse.message };
  } catch (error) {
    return { error: true, data: error };
  }
};

// change personal info
const putUser = async (lineProfile, userData) => {
  try {
    const response = await fetch(`${API_URL}/users`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-line-id": lineProfile.userId,
      },
      body: JSON.stringify({
        data: userData,
      }),
    });
    const jsonResponse = await response.json();
    console.log(`putUser api: jsonResponse ${JSON.stringify(jsonResponse)}`);
    return { error: jsonResponse.error, data: jsonResponse.message };
  } catch (error) {
    return { error: true, data: error };
  }
};

//the api to show the product when users use scanner the qrcode or handadding
const findProduct = async (lineProfile, productCode) => {
  try {
    const response = await fetch(`${API_URL}/products/${productCode}`, {
      method: "GET",
      headers: {
        "x-line-id": lineProfile.userId,
        "Content-type": "application/json",
      },
    });
    const jsonResponse = await response.json();
    console.log(
      `findProduct api: jsonResponse ${JSON.stringify(jsonResponse)}`
    );
    return { error: jsonResponse.error, data: jsonResponse.message };
  } catch (error) {
    return { error: true, data: error };
  }
};

// user register the product code to open VIP identity
const postUserProduct = async (lineProfile, productCode) => {
  try {
    console.log("from frontend postUserProduct", lineProfile, productCode);
    const response = await fetch(`${API_URL}/users/products`, {
      method: "POST",
      headers: {
        "x-line-id": lineProfile.userId,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        productCode: productCode,
      }),
    });
    const jsonResponse = await response.json();
    console.log(
      `postUserProduct api: jsonResponse ${JSON.stringify(jsonResponse)}`
    );
    return { error: jsonResponse.error, data: jsonResponse.message };
  } catch (error) {
    console.error(error);
    return { error: true, data: error };
  }
};

const postReservation = async (lineProfile, inputData) => {
  try {
    const response = await fetch(`${API_URL}/reservations`, {
      method: "POST",
      headers: {
        "x-line-id": lineProfile.userId,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        remark: inputData.remark,
        date: inputData.date,
        time: inputData.time,
        type: inputData.type,
      }),
    });
    const jsonResponse = await response.json();
    console.log(`postReserv api: jsonResponse: ${jsonResponse}`);
    return { error: false, data: jsonResponse.message };
  } catch (error) {
    console.error(error);
    return { error: true, data: error };
  }
};

const getUserProduct = async (lineProfile) => {
  try {
    const response = await fetch(`${API_URL}/users/products`, {
      method: "GET",
      headers: {
        "x-line-id": lineProfile.userId,
      },
    });
    const jsonResponse = await response.json();
    console.log(
      `getUserProduct api: jsonResponse ${JSON.stringify(jsonResponse)}`
    );
    return { error: jsonResponse.error, data: jsonResponse.message };
  } catch (error) {
    console.error(error);
    return { error: true, data: error };
  }
};

const getClinic = async (lineProfile, email) => {
  try {
    console.log(`${API_URL}/clinics/${email}`);
    const response = await fetch(`${API_URL}/clinics/${email}`, {
      method: "GET",
      headers: {
        "x-line-id": lineProfile.userId,
      },
    });
    const jsonResponse = await response.json();
    console.log(`getClinic api: jsonResponse ${JSON.stringify(jsonResponse)}`);
    return { error: jsonResponse.error, data: jsonResponse.message };
  } catch (error) {
    return { error: true, data: error };
  }
};

// every pages would call this api before rendering to make sure the user has an account it sharpgun
const auth = async (lineId) => {
  try {
    const response = await fetch(`${API_URL}/auth`, {
      method: "GET",
      headers: {
        "x-line-id": lineId,
      },
    });
    const jsonResponse = await response.json();
    console.log(`auth api: jsonResponse ${JSON.stringify(jsonResponse)}`);
    return { error: jsonResponse.error, data: jsonResponse.message };
  } catch (error) {
    console.log("error", error);
    return { error: true, data: `error` };
  }
};

//new one
const initUserClinic = async (lineProfile, email) => {
  try {
    const response = await fetch(`${API_URL}/users`, {
      method: "POST",
      headers: {
        "x-line-id": lineProfile.userId,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        name: lineProfile.displayName,
      }),
    });

    const jsonResponse = await response.json();
    console.log(
      `initUserClinic api: jsonResponse ${JSON.stringify(jsonResponse)}`
    );
    return { error: jsonResponse.error, data: jsonResponse.message };
  } catch (error) {
    console.log("error", error);
    return { error: true, data: error };
  }
};

const putClinic = async (lineProfile, inputData, nameFix=false) => {
  try {
    let newInputData, hostName;
    if (nameFix) {
      ({ hostName, ...newInputData } = inputData);
    } else {
      newInputData = inputData; 
    }
    const response = await fetch(`${API_URL}/clinics`, {
      method: "PUT",
      headers: {
        "x-line-id": lineProfile.userId,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        data: newInputData,
      }),
    });
    const jsonResponse = await response.json();
    console.log(`putClinic api: jsonResponse ${JSON.stringify(jsonResponse)}`);
    return { error: jsonResponse.error, data: jsonResponse.message };
  } catch (error) {
    console.log("error", error);
    return { error: true, data: error };
  }
};

const getReservation = async (lineProfile, reservId) => {
  let url ;
  if(reservId) url = `${API_URL}/reservations/${reservId}`;
  else url = `${API_URL}/reservations`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "x-line-id": lineProfile.userId,
      },
    });
    const jsonResponse = await response.json();
    console.log(
      `getReservation api: jsonResponse ${JSON.stringify(jsonResponse)}`
    );
    return { error: jsonResponse.error, data: jsonResponse.message };
  } catch (error) {
    console.log("error", error);
    return { error: true, data: error };
  }
};

const deleteRerservation = async (lineProfile, reservId) => {
  try {
    const response = await fetch(`${API_URL}/reservations/${reservId}`, {
      method: "DELETE",
      headers: {"x-line-id" : lineProfile.userId}
    });
    const jsonResponse = await response.json();
    console.log(
      `deleteRerservation api: jsonResponse ${JSON.stringify(jsonResponse)}`
    )
    return { error: jsonResponse.error, data: jsonResponse.message };
  } catch (error) {
    console.log("error", error);
    return { error: true, data: error };
  }
};

const putReservation = async (lineProfile, inputData) => {
  try{
    console.log(`putReserve api: inputData ${JSON.stringify(inputData)}`);
    const response = await fetch(`${API_URL}/reservations/${inputData.reservId}`, {
      method: "PUT",
      headers:{
        "x-line-id": lineProfile.userId,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        data: inputData
      }) 
    }) ;
    const jsonResponse = await response.json();
    console.log(`putReservation api: response ${JSON.stringify(jsonResponse)}`);
    return { error: jsonResponse.error, data: jsonResponse.message };
  }catch(error){
    console.log("error", error);
    return { error: true, data: error };
  }
} ;

const deleteUser = async (lineProfile) =>{
  try{
    const response = await fetch(`${API_URL}/users`, {
      method: "DELETE",
      headers:{
        "x-line-id": lineProfile.userId,
        "Content-Type": "application/json",
      },
    }) ;
    const jsonResponse = await response.json();
    console.log(`putReservation api: response ${JSON.stringify(jsonResponse)}`);
    return { error: jsonResponse.error, data: jsonResponse.message };

  }catch(error){
    console.log("error", error);
    return { error: true, data: error };
  }
}

module.exports = {
  auth,
  postUserProduct,
  getUserProduct,
  findProduct,
  getClinic,
  getUser,
  postReservation,
  putUser,
  initUserClinic,
  getReservation,
  putClinic,
  deleteRerservation,
  putReservation,
  deleteUser
};
